import * as Yup from 'yup'

const validationObject = window.Sepia.ValidationSchema.membership
const sepia = window.Sepia.Validation

Yup.addMethod(Yup.mixed, 'sepiaValidate', function (name) {
  return this.test('sepiaValidate', '', function(value) {

    let validationArray = Object.entries(validationObject[name]).reverse()

    try {

      let error
      let validateFunction
      for (let i = 0; i < Object.keys(validationArray).length; i++) {
        validateFunction = sepia().rule(validationArray[i][0])(validationArray[i][1])
        error = validateFunction(value)

        if (error) {
          if (typeof error === 'string') {
            return this.createError({
              message: error
            })
          }
          if (typeof error === 'boolean') {
            return error
          }
        }
      }

    } catch (e) {
      return false
    }

  })
})

Yup.addMethod(Yup.mixed, 'validateDob', function (name) {
  return this.test('validateDob', '', function(value) {

    try {

      if (!value) {
        return this.createError({
          message: 'Please enter your date of birth'
        })
      }

      console.log(value)
      if (value && value.length === 10) {
        var d = value.split('/')
        var d2 = d[1] + '/' + d[0] + '/' + d[2]
        var onDate = new Date()
        var birthDate = new Date(d2)
        var age = onDate.getFullYear() - birthDate.getFullYear()
        var m = onDate.getMonth() - birthDate.getMonth()
        if (m < 0 || (m === 0 && onDate.getDate() < birthDate.getDate())) {
            age--;
        }
        if (age >= 16 && age <= 29) {
          return
        } else {
          return this.createError({
            message: 'You must be between 16 and 29 years old for this membership type'
          })
        }

      } else {
        return this.createError({
          message: 'Please enter a valid date'
        })
      }

    } catch (e) {
      return false
    }

  })
})

Yup.addMethod(Yup.mixed, 'sepiaValidatePhone', function () {
  return this.test('sepiaValidatePhone', '', function() {

    let value = document.getElementById('m-phone-number').value
    let country = document.getElementById('country').innerHTML
    let validateFunction, error

    try {

      if (!value) {
        return
      }

      if (country === 'United Kingdom') {
        validateFunction = sepia().rule('uk_phone', {})()
      } else {
        validateFunction = sepia().rule('int_phone', {})()
      }
      error = validateFunction(value)

      if (error) {
        if (typeof error === 'string') {
          return this.createError({
            message: error
          })
        }
        if (typeof error === 'boolean') {
          return error
        }
      }

    } catch (e) {
      return false
    }

  })
})

Yup.addMethod(Yup.mixed, 'sepiaValidatePostcode', function () {
  return this.test('sepiaValidatePostcode', '', function() {

    let value = document.getElementById('postcode').value
    let country = document.getElementById('country').innerHTML
    let validationArray = Object.entries(validationObject.postcode).reverse()

    try {

      let error
      let validateFunction
      for (let i = 0; i < Object.keys(validationArray).length; i++) {
        validateFunction = sepia().rule(validationArray[i][0])(validationArray[i][1])
        error = validateFunction(value)

        if (error) {
          if (typeof error === 'string') {
            return this.createError({
              message: error
            })
          }
          if (typeof error === 'boolean') {
            return error
          }
        }
      }

      if (country === 'United Kingdom') {
        validateFunction = sepia().rule('uk_postcode', {})()
        error = validateFunction(value)

        if (error) {
          if (typeof error === 'string') {
            return this.createError({
              message: error
            })
          }
          if (typeof error === 'boolean') {
            return error
          }
        }
      }

    } catch (e) {
      return false
    }

  })
})